export default "<!--<app-loader></app-loader>-->\r\n<router-outlet></router-outlet>\r\n"